import "@/landing.css";
import { useReveal, Wordmark } from "@/components/landing/shared";
import { Seo } from "@/components/public/Seo";
import content from "@/pages/public/publicContent.json";
import { LandingHeader } from "@/components/landing/LandingHeader";
import { LandingHero } from "@/components/landing/LandingHero";
import {
  ProblemaSection, SoluzioneSection, VsmeSection, PmiBancheSection, JobtimehrSection,
} from "@/components/landing/LandingFrameworks";
import {
  EsgSection, CarbonSection, EvaSection, DocumentiSection,
} from "@/components/landing/LandingFeatures";
import {
  PercorsoSection, DifferenziatoreSection, PerChiSection, TrasparenzaSection, SicurezzaSection,
} from "@/components/landing/LandingTrust";
import { PreviewSection, CtaFinaleSection, LandingFooter } from "@/components/landing/LandingClosing";

export { Wordmark };

export default function Landing() {
  const rootRef = useReveal();
  const home = content.routes.find((r) => r.path === "/");

  return (
    <div ref={rootRef} className="bg-white text-slate-900 antialiased" data-testid="landing-page"
      style={{ fontFamily: "Inter, sans-serif" }}>
      <Seo title={home.title} description={home.description} path="/"
        jsonLd={[{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "ESG-PMI",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web",
          inLanguage: "it-IT",
          description: home.description,
        }]} />
      <LandingHeader />
      <main>
        <LandingHero />
        <ProblemaSection />
        <SoluzioneSection />
        <VsmeSection />
        <PmiBancheSection />
        <JobtimehrSection />
        <EsgSection />
        <CarbonSection />
        <EvaSection />
        <DocumentiSection />
        <PercorsoSection />
        <DifferenziatoreSection />
        <PerChiSection />
        <TrasparenzaSection />
        <SicurezzaSection />
        <PreviewSection />
        <CtaFinaleSection />
      </main>
      <LandingFooter />
    </div>
  );
}
